// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const zHttpError = z.object({
    statusCode: z.number(),
    message: z.string(),
    details: z.unknown().optional()
});

export const zValidationError = z.object({
    statusCode: z.literal(400),
    message: z.string(),
    details: z.object({
        issues: z.array(z.object({
            in: z.enum([
                'params',
                'query',
                'body'
            ]),
            path: z.array(z.union([
                z.string(),
                z.number()
            ])),
            message: z.string(),
            code: z.string()
        }))
    })
});

export const zRealtimeTokenRequest = z.object({
    keyName: z.string(),
    clientId: z.string().optional(),
    capability: z.string(),
    timestamp: z.number(),
    nonce: z.string(),
    mac: z.string(),
    ttl: z.number().optional()
});

export const zPromptVersion = z.object({
    id: z.string().regex(/^apv_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
    agentId: z.string().regex(/^agt_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
    version: z.int().gte(-9007199254740991).lte(9007199254740991),
    systemPrompt: z.string(),
    model: z.string(),
    note: z.string(),
    createdBy: z.string().nullable(),
    createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z))$/)
});

export const zAgent = z.object({
    id: z.string().regex(/^agt_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
    slug: z.string(),
    name: z.string(),
    description: z.string(),
    activeVersion: zPromptVersion,
    createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z))$/),
    updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z))$/)
});

export const zAgentRunStatus = z.enum([
    'queued',
    'running',
    'succeeded',
    'failed'
]);

export const zAgentRun = z.object({
    id: z.string().regex(/^run_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
    agentId: z.string().regex(/^agt_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
    promptVersionId: z.string().regex(/^apv_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
    input: z.record(z.string(), z.unknown()),
    status: zAgentRunStatus,
    output: z.string().nullable(),
    error: z.string().nullable(),
    createdBy: z.string().nullable(),
    startedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z))$/).nullable(),
    finishedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z))$/).nullable(),
    createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z))$/)
});

export const zPersona = z.object({
    id: z.string().regex(/^per_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
    name: z.string(),
    description: z.string(),
    rules: z.string(),
    createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z))$/),
    updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z))$/)
});

export const zUserWithPersonas = z.object({
    id: z.string().regex(/^usr_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
    email: z.string(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z))$/),
    updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z))$/),
    personaIds: z.array(z.string().regex(/^per_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/))
});

export const zAuthUser = z.object({
    id: z.string(),
    email: z.string(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable()
});

export const zGoogleConnectionStart = z.object({
    url: z.url()
});

export const zConnection = z.object({
    id: z.string().regex(/^con_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
    kind: z.enum(['google', 'mcp']),
    label: z.string(),
    scopes: z.array(z.string()),
    status: z.enum(['active', 'needs_reauth']),
    createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z))$/),
    updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z))$/)
});

export const zCalendarPersona = z.object({
    id: z.string().regex(/^per_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
    name: z.string()
});

export const zCalendarSummary = z.object({
    id: z.string().regex(/^cal_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
    name: z.string(),
    color: z.string().nullable(),
    accountLabel: z.string(),
    personaIds: z.array(z.string().regex(/^per_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/))
});

export const zCalendarEvent = z.object({
    id: z.string().regex(/^evt_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
    calendarId: z.string().regex(/^cal_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
    summary: z.string(),
    location: z.string().nullable(),
    startsAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z))$/),
    endsAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z))$/),
    allDay: z.boolean(),
    status: z.enum(['confirmed', 'tentative']),
    htmlLink: z.string().nullable()
});

export const zCalendarEvents = z.object({
    personas: z.array(zCalendarPersona),
    calendars: z.array(zCalendarSummary),
    events: z.array(zCalendarEvent)
});

export const zTaskPriority = z.enum([
    'low',
    'normal',
    'high'
]);

export const zRepeatUnit = z.enum([
    'day',
    'week',
    'month',
    'year'
]);

/**
 * e.g. { "every": 2, "unit": "week" } is fortnightly
 */
export const zTaskRecurrence = z.object({
    every: z.int().gte(1).lte(365),
    unit: zRepeatUnit
});

export const zTask = z.object({
    id: z.string().regex(/^tsk_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
    title: z.string(),
    personaId: z.string().regex(/^per_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/).nullable(),
    dueOn: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/).nullable(),
    priority: zTaskPriority,
    estimateMinutes: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
    recurrence: zTaskRecurrence.nullable(),
    completedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z))$/).nullable(),
    createdByRunId: z.string().nullable(),
    createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z))$/),
    updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z))$/)
});

export const zCaptureTasksAccepted = z.object({
    runId: z.string().regex(/^run_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)
});

export const zTaskBlock = z.object({
    id: z.string().regex(/^blk_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
    taskId: z.string().regex(/^tsk_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
    title: z.string(),
    personaId: z.string().regex(/^per_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/).nullable(),
    done: z.boolean(),
    day: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/),
    startsAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z))$/),
    endsAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z))$/),
    runId: z.string().nullable()
});

export const zPlanDayAccepted = z.object({
    runId: z.string().regex(/^run_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)
});

export const zCreatePromptVersion = z.object({
    systemPrompt: z.string().min(1).max(100000),
    model: z.string().min(1).max(100),
    note: z.string().max(500).optional().default(''),
    activate: z.boolean().optional().default(true)
});

export const zCreatePersona = z.object({
    name: z.string().min(1).max(100),
    description: z.string().max(100000).optional().default(''),
    rules: z.string().max(100000).optional().default('')
});

export const zUpdatePersona = z.object({
    name: z.string().min(1).max(100).optional(),
    description: z.string().max(100000).optional(),
    rules: z.string().max(100000).optional()
});

export const zSetUserPersonas = z.object({
    personaIds: z.array(z.string().regex(/^per_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)).max(200)
});

export const zStartGoogleConnection = z.object({
    personaId: z.string().regex(/^per_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)
});

export const zCreateTask = z.object({
    title: z.string().min(1).max(500),
    personaId: z.string().regex(/^per_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/).nullish().default(null),
    dueOn: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/).nullish().default(null),
    priority: zTaskPriority.optional().default('normal'),
    estimateMinutes: z.int().gte(1).lte(10080).nullish().default(null),
    recurrence: zTaskRecurrence.nullish().default(null)
});

export const zUpdateTask = z.object({
    title: z.string().min(1).max(500).optional(),
    personaId: z.string().regex(/^per_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/).nullish(),
    dueOn: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/).nullish(),
    priority: zTaskPriority.optional(),
    estimateMinutes: z.int().gte(1).lte(10080).nullish(),
    recurrence: zTaskRecurrence.nullish(),
    done: z.boolean().optional()
});

export const zCaptureTasks = z.object({
    text: z.string().min(1).max(20000),
    timeZone: z.string()
});

/**
 * OK
 */
export const zRealtimeTokenResponse = zRealtimeTokenRequest;

/**
 * OK
 */
export const zAgentsListResponse = z.array(zAgent);

export const zAgentsGetPath = z.object({
    id: z.string().regex(/^agt_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)
});

/**
 * OK
 */
export const zAgentsGetResponse = zAgent;

export const zAgentsVersionsPath = z.object({
    id: z.string().regex(/^agt_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)
});

/**
 * OK
 */
export const zAgentsVersionsResponse = z.array(zPromptVersion);

export const zAgentsCreateVersionBody = zCreatePromptVersion;

export const zAgentsCreateVersionPath = z.object({
    id: z.string().regex(/^agt_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)
});

/**
 * Created
 */
export const zAgentsCreateVersionResponse = zPromptVersion;

export const zAgentsActivatePath = z.object({
    id: z.string().regex(/^agt_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
    versionId: z.string().regex(/^apv_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)
});

/**
 * OK
 */
export const zAgentsActivateResponse = zAgent;

export const zAgentRunsListQuery = z.object({
    agentId: z.string().regex(/^agt_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/).optional(),
    limit: z.int().gte(1).lte(100).optional().default(20)
});

/**
 * OK
 */
export const zAgentRunsListResponse = z.array(zAgentRun);

export const zAgentRunsGetPath = z.object({
    id: z.string().regex(/^run_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)
});

/**
 * OK
 */
export const zAgentRunsGetResponse = zAgentRun;

/**
 * OK
 */
export const zPersonasListResponse = z.array(zPersona);

export const zPersonasCreateBody = zCreatePersona;

/**
 * Created
 */
export const zPersonasCreateResponse = zPersona;

export const zPersonasRemovePath = z.object({
    id: z.string().regex(/^per_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)
});

/**
 * No content
 */
export const zPersonasRemoveResponse = z.void();

export const zPersonasGetPath = z.object({
    id: z.string().regex(/^per_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)
});

/**
 * OK
 */
export const zPersonasGetResponse = zPersona;

export const zPersonasUpdateBody = zUpdatePersona;

export const zPersonasUpdatePath = z.object({
    id: z.string().regex(/^per_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)
});

/**
 * OK
 */
export const zPersonasUpdateResponse = zPersona;

/**
 * OK
 */
export const zUsersListResponse = z.array(zUserWithPersonas);

export const zUsersSetPersonasBody = zSetUserPersonas;

export const zUsersSetPersonasPath = z.object({
    id: z.string().regex(/^usr_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)
});

/**
 * OK
 */
export const zUsersSetPersonasResponse = zUserWithPersonas;

/**
 * OK
 */
export const zMeMeResponse = zAuthUser;

/**
 * No content
 */
export const zJobsDescribeResponse = z.void();

/**
 * No content
 */
export const zJobsSyncResponse = z.void();

export const zGoogleOAuthStartBody = zStartGoogleConnection;

/**
 * Created
 */
export const zGoogleOAuthStartResponse = zGoogleConnectionStart;

export const zGoogleOAuthCallbackQuery = z.object({
    code: z.string().optional(),
    state: z.string().optional(),
    error: z.string().optional()
});

/**
 * No content
 */
export const zGoogleOAuthCallbackResponse = z.void();

export const zPersonaConnectionsListPath = z.object({
    id: z.string().regex(/^per_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)
});

/**
 * OK
 */
export const zPersonaConnectionsListResponse = z.array(zConnection);

export const zPersonaConnectionsUnlinkPath = z.object({
    id: z.string().regex(/^per_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
    connectionId: z.string().regex(/^con_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)
});

/**
 * No content
 */
export const zPersonaConnectionsUnlinkResponse = z.void();

export const zCalendarEventsListQuery = z.object({
    from: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/),
    to: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/),
    personaIds: z.union([
        z.string().regex(/^per_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
        z.array(z.string().regex(/^per_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/))
    ]).optional()
});

/**
 * OK
 */
export const zCalendarEventsListResponse = zCalendarEvents;

/**
 * No content
 */
export const zGoogleCalendarWebhookNotifyResponse = z.void();

/**
 * OK
 */
export const zHealthHealthResponse = z.object({
    status: z.literal('ok')
});

export const zTasksListQuery = z.object({
    status: z.enum([
        'open',
        'done',
        'all'
    ]).optional().default('open'),
    personaIds: z.union([
        z.string().regex(/^per_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
        z.array(z.string().regex(/^per_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/))
    ]).optional()
});

/**
 * OK
 */
export const zTasksListResponse = z.array(zTask);

export const zTasksCreateBody = zCreateTask;

/**
 * Created
 */
export const zTasksCreateResponse = zTask;

export const zTasksRemovePath = z.object({
    id: z.string().regex(/^tsk_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)
});

/**
 * No content
 */
export const zTasksRemoveResponse = z.void();

export const zTasksUpdateBody = zUpdateTask;

export const zTasksUpdatePath = z.object({
    id: z.string().regex(/^tsk_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)
});

/**
 * OK
 */
export const zTasksUpdateResponse = zTask;

export const zTaskCaptureCreateBody = zCaptureTasks;

/**
 * Accepted
 */
export const zTaskCaptureCreateResponse = zCaptureTasksAccepted;

export const zPlanningListQuery = z.object({
    from: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/),
    to: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/)
});

/**
 * OK
 */
export const zPlanningListResponse = z.array(zTaskBlock);

export const zPlanningPlanPath = z.object({
    day: z.iso.date().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))$/)
});

/**
 * Accepted
 */
export const zPlanningPlanResponse = zPlanDayAccepted;
